import angular from 'angular';

/** @ngInject */
export default function appBootstrap($transitions, HealthCheckerService) {
    $transitions.onStart({}, (trans) => {
        const DialogService = trans.injector().get('DialogService');
        DialogService.cancel();
        const helpMenuNode = document.querySelector('dt-help-menu');
        if (helpMenuNode) {
            const { $ctrl } = angular.element(helpMenuNode).scope();
            $ctrl.mdPanelRef.close();
        }
    });

    HealthCheckerService.initTracking();
}



// WEBPACK FOOTER //
// ./app/app.bootstrap.js